const objectBederr = {
  name: 'validator',
  nameBusiness: 'Bederr',
  color: '#007faa',
  apykey: '5807700d-0a46-4d0d-a26f-60eee2fbc963',
};


export const Whitelabel = objectBederr;
